import * as React from "react";
import { forwardRef } from "react";
import clsx from "clsx";
import omit from "lodash/omit";
import { rainbowSprinkles } from "../../styles/rainbow-sprinkles.css";
import type { BoxProps } from "./box.types";
import { DEFAULT_VALUES } from "./box.types";

const Box = forwardRef<any, BoxProps>(function Box(props: BoxProps, boxRef: BoxProps["boxRef"]) {
  function comp() {
    return props.as ?? DEFAULT_VALUES.as;
  }

  function finalPassThroughProps() {
    return boxStyles().passThroughProps;
  }

  function boxStyles() {
    const sprinklesObj = rainbowSprinkles({
      ...omit(props, ["attributes", "as", "boxRef"]),
      ...props.attributes,
    });
    return {
      className: clsx(sprinklesObj.className, props.className),
      style: sprinklesObj.style,
      passThroughProps: omit(sprinklesObj.otherProps, [
        "attributes",
        "style",
        "rawCSS",
        "colorScheme",
      ]),
    };
  }

  const CompRef = comp();

  return (
    <CompRef
      style={{
        ...boxStyles().style,
        ...props.attributes?.style,
        ...props.rawCSS,
      }}
      {...finalPassThroughProps()}
      ref={props.boxRef ?? boxRef}
      className={boxStyles().className}
    >
      {props.children}
    </CompRef>
  );
});

export default Box;
